import React from 'react';
import { useDownload } from '../../context/DownloadContext';
import Button from '../ui/Button';

// Sits on top of imagery, so it uses the shared `glass` variant rather than the
// one-off inline style it used to carry.
const DownloadButton = ({ url, filename }) => {
    const { download, downloading } = useDownload();
    const isBusy = downloading === url;

    return (
        <Button
            variant="glass"
            onClick={() => download(url, filename)}
            disabled={isBusy}
            className="disabled:cursor-wait"
        >
            {isBusy ? 'Saving…' : 'Download'}
        </Button>
    );
};

export default DownloadButton;
